import {
  AccountBalanceWallet,
  Add,
  AddCard,
  Article,
  Assessment,
  AttachMoney,
  Build,
  Cancel,
  CarRepairOutlined,
  Check,
  CheckCircle,
  CreditCard,
  Folder,
  Info,
  ListAltOutlined,
  LocalActivity,
  LocalParking,
  Lock,
  ManageSearchOutlined,
  Money,
  NotificationsActive,
  Receipt,
  ReceiptLong,
  ReplayOutlined,
  Search,
  Send,
  SyncAlt,
  SyncAltOutlined,
  // CreditCardOutlined,
  // Wallet,
  // Inventory2Outlined,
  // Dashboard as DashboardIcon,
  // SwapHoriz,
  // PublishedWithChanges,
  // FactCheckOutlined,
  // DeleteSweepOutlined,
  // RequestQuoteOutlined,
} from "@mui/icons-material";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import {
  Car,
  CarOutline,
  CashOutline,
  CheckmarkDone,
  Clipboard,
  Document,
  DocumentTextOutline,
  GridOutline,
  HourglassOutline,
  LayersOutline,
  LockOpen,
  Pricetags,
  SettingsOutline,
  ShieldCheckmarkOutline,
  Ticket,
  TicketOutline,
  TrainOutline,
} from "@raresail/react-ionicons";
import { Menu } from "antd";
import { useSettings } from "../../constants/settings";
import { useGlobalContext } from "../../context/GlobalContext";
import { useModals } from "../../hooks/common/useModal";
import {
  ADVANCE,
  APPROVED,
  // CAN_DISPOSE_ASSETS,
  // CAN_PERFORM_ASSET_STOCK_COUNT,
  // CAN_REGISTER_ASSETS,
  // CAN_TRANSFER_ASSETS,
  // CAN_UPDATE_ASSET_STATUS,
  // CAN_VIEW_ASSETS,
  CLAMPED,
  CONFIRMED,
  NOTIFIED,
  // PENDING,
  // PENDING_APPROVAL,
  // PENDING_REVIEW,
  REJECTED,
  RESERVATION,
  STICKER,
  SUBMITTED,
  UNCLAMPED,
} from "../../utils/constants";
import {
  getForm,
  getRegister,
  // useGetUserPermissions,
} from "../../utils/helpers";
import {
  IsAccountant,
  IsAdmin,
  ISAgentUser,
  IsEnforcement,
  IsHeadOfAccountant,
  IsManager,
  IsSuperUser,
} from "../../utils/permissions";
import {
  URL_ADVANCES_BALANCE,
  URL_ADVANCES_TRANSACTIONS,
  URL_BILLING_INVOICES,
  URL_BOOKINGS,
  URL_COUPON_SALES,
  URL_CURRENTLY_PARKED_CARS,
  URL_LEDGERS,
  URL_LINKED_CARS,
  URL_LIQUIDATION_REQUESTS,
  URL_NEGOTIATED_PAYMENTS,
  URL_PAID_REQUESTS,
  URL_PARKED_CARS,
  URL_PARKED_CARS_SERVICES,
  URL_PAYMENT_REQUESTS,
  URL_RECONCILIATION_ERROR_LOGS,
  URL_RECONCILIATIONS,
  URL_STATEMENT_LOGS,
  URL_SURCHARGES,
  URL_TRANSACTABLE_ACCOUNTS_DETAILS,
  URL_VEHICLE_CLAMPING,
  URL_PENALTIES,
  URL_REVERSAL_REQUESTS,
  URL_REVERSAL_HOLDINGS,
  URL_DORMANT_ACCOUNTS,
  // URL_STAFF_WAGES,
  // URL_DAILY_WAGES_COLLECTIONS,
  // URL_FIXED_WAGES,
  // URL_WAGE_ADVANCEMENTS,
  // DEFERRED,
  // URL_ASSETS,
  // URL_ASSETS_DASHBOARD,
  // URL_ASSET_TRANSFERS,
  // URL_ASSET_STATUS_UPDATES,
  // URL_ASSET_STOCK_COUNTS,
  // URL_ASSET_DISPOSALS,
  // URL_PETTY_CASH_REQUISITION,
  // URL_STAFF_WAGES_REQUISITION,
} from "../../utils/urls";
import { RecursiveMenu } from "../menu/RecursiveMenu";
import styled from "styled-components";
import { useEffect, useState } from "react";

function LeftMenuItems(): any {
  const { setOpenVehicleStatus, setOpenVehicleLedger, setOpenAdvanceBalance } =
    useModals();

  const isSupper = IsSuperUser();
  const isAdmin = IsAdmin();
  const isAgent = ISAgentUser();
  const isManager = IsManager();
  const isAccountant = IsAccountant();
  const isEnforcement = IsEnforcement();
  const isHeadOfAccountant = IsHeadOfAccountant();
  // const permissions: string[] = useGetUserPermissions();
  // const can = (permission: string) => permissions.includes(permission);

  // // pending / approved / rejected sub-registers for approval-based asset flows
  // const approvalRegisters = (url: string, icon: any) => [
  // { label: "All", icon, to: getRegister(url) },
  // { label: "Pending", icon, to: getRegister(url, PENDING) },
  // { label: "Approved", icon, to: getRegister(url, APPROVED) },
  // { label: "Rejected", icon, to: getRegister(url, REJECTED) },
  // ];

  const menu: any = [
    // HOME
    {
      label: "Dashboard",
      to: "/",
      visible: true,
      key: "default",
      icon: <GridOutline />,
    },

    // CARS
    {
      label: "Cars",
      icon: <CarOutline />,
      visible: isAgent || isAdmin || isSupper || isAccountant || isManager,
      children: [
        {
          label: "Currently Parked Cars",
          icon: <LocalActivity />,
          to: getRegister(URL_CURRENTLY_PARKED_CARS),
        },
        {
          label: "All Parked Cars",
          icon: <LocalParking />,
          to: getRegister(URL_PARKED_CARS),
        },
        {
          label: "Parked Car Services",
          icon: <Build />,
          to: getRegister(
            `${URL_PARKED_CARS_SERVICES}?service_name=loading & service_name=offloading`,
          ),
        },
      ],
    },

    // VEHICLE STATUS
    {
      label: "Vehicle Status",
      icon: <ShieldCheckmarkOutline />,

      click: () => {
        setOpenVehicleStatus();
      },
    },
    {
      label: "Vehicle Ledger",
      icon: <ManageSearchOutlined />,
      click: () => {
        setOpenVehicleLedger();
      },
    },

    // VEHICLE CLAMPING
    {
      label: "Vehicle Clamping",
      icon: <CarRepairOutlined />,
      visible: isSupper || isAdmin || isManager || isEnforcement,
      children: [
        {
          label: "Clamped",
          icon: <Lock />,
          to: `${getRegister(URL_VEHICLE_CLAMPING)}/${CLAMPED}?action_type=${CLAMPED}`,
          visible: true,
        },
        {
          label: "Notified",
          icon: <NotificationsActive />,
          to: `${getRegister(URL_VEHICLE_CLAMPING)}/${NOTIFIED}?action_type=${NOTIFIED}`,
          visible: true,
        },
        {
          label: "Unclamped",
          icon: <LockOpen />,
          to: `${getRegister(URL_VEHICLE_CLAMPING)}/${UNCLAMPED}?action_type=${UNCLAMPED}`,
          visible: true,
        },
      ],
    },

    // PAYMENTS
    {
      label: "Payments",
      icon: <AttachMoney />,
      visible:
        isAgent ||
        isSupper ||
        isAdmin ||
        isAccountant ||
        isManager ||
        isHeadOfAccountant,
      children: [
        {
          label: "Invoices",
          icon: <Receipt />,
          to: getRegister(URL_BILLING_INVOICES),
        },
        {
          label: "Payments",
          icon: <CreditCard />,
          to: getRegister(URL_PAID_REQUESTS),
        },
        {
          label: "Payment Requests",
          icon: <AddCard />,
          to: getRegister(URL_PAYMENT_REQUESTS),
        },
        // PENALTY SETTINGS
        {
          label: "Negotiations",
          icon: <CashOutline />,
          to: getRegister(URL_NEGOTIATED_PAYMENTS),
        },

        // SURCHARGES
        {
          label: "Surcharges",
          icon: <Money />,
          to: getRegister(URL_SURCHARGES),
          visible: isSupper,
        },
        // PENALTIES
        {
          label: "Penalties",
          icon: <Money />,
          to: getRegister(URL_PENALTIES),
          visible: isSupper,
        },
      ],
    },

    // // WAGES
    // {
    // label: "Wages",
    // icon: <Wallet />,
    // visible: isAdmin || isSupper || isHeadOfAccountant || isManager,
    // children: [
    // {
    // label: "Weekly Wages",
    // icon: <Wallet />,
    // to: getRegister(URL_STAFF_WAGES),
    // },
    // {
    // label: "Daily Collections",
    // icon: <Wallet />,
    // to: getRegister(URL_DAILY_WAGES_COLLECTIONS),
    // },
    // {
    // label: "Fixed Wages",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_FIXED_WAGES),
    // },
    // {
    // label: "Wage Advancements",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_WAGE_ADVANCEMENTS),
    // children: [
    // {
    // label: "Pending",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_WAGE_ADVANCEMENTS, PENDING),
    // },
    // {
    // label: "Pending Review",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_WAGE_ADVANCEMENTS, PENDING_REVIEW),
    // },
    // {
    // label: "Pending Approval",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_WAGE_ADVANCEMENTS, PENDING_APPROVAL),
    // },
    // {
    // label: "Approved",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_WAGE_ADVANCEMENTS, APPROVED),
    // },
    // {
    // label: "Deferred",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_WAGE_ADVANCEMENTS, DEFERRED),
    // },
    // {
    // label: "Rejected",
    // icon: <CreditCardOutlined />,
    // to: getRegister(URL_WAGE_ADVANCEMENTS, REJECTED),
    // },
    // ],
    // },
    // ],
    // },

    // //    // REQUISITIONS
    // {
    // label: "Requisitions",
    // icon: <RequestQuoteOutlined />,
    // visible:
    // isAdmin || isSupper || isHeadOfAccountant || isManager || isAccountant,
    // children: [
    // {
    // label: "Staff Wages Requisitions",
    // icon: <Wallet />,
    // to: getRegister(URL_STAFF_WAGES_REQUISITION),
    // children: [
    // {
    // label: "Submitted",
    // icon: <Send />,
    // to: getRegister(URL_STAFF_WAGES_REQUISITION, PENDING),
    // },
    // {
    // label: "Pending Review",
    // icon: <ManageSearchOutlined />,
    // to: getRegister(URL_STAFF_WAGES_REQUISITION, PENDING_REVIEW),
    // },
    // {
    // label: "Pending Approval",
    // icon: <ManageSearchOutlined />,
    // to: getRegister(URL_STAFF_WAGES_REQUISITION, PENDING_APPROVAL),
    // },
    // {
    // label: "Approved",
    // icon: <CheckCircle />,
    // to: getRegister(URL_STAFF_WAGES_REQUISITION, APPROVED),
    // },
    // {
    // label: "Deferred",
    // icon: <ReplayOutlined />,
    // to: getRegister(URL_STAFF_WAGES_REQUISITION, DEFERRED),
    // },
    // {
    // label: "Rejected",
    // icon: <Cancel />,
    // to: getRegister(URL_STAFF_WAGES_REQUISITION, REJECTED),
    // },
    // ],
    // },
    // {
    // label: "Petty Cash Requisitions",
    // icon: <CashOutline />,
    // to: getRegister(URL_PETTY_CASH_REQUISITION),
    // children: [
    // {
    // label: "New Petty Cash Requisition",
    // icon: <Add />,
    // to: getForm(URL_PETTY_CASH_REQUISITION),
    // },
    // {
    // label: "Submitted",
    // icon: <Send />,
    // to: getRegister(URL_PETTY_CASH_REQUISITION, PENDING),
    // },
    // {
    // label: "Pending Review",
    // icon: <ManageSearchOutlined />,
    // to: getRegister(URL_PETTY_CASH_REQUISITION, PENDING_REVIEW),
    // },
    // {
    // label: "Pending Approval",
    // icon: <ManageSearchOutlined />,
    // to: getRegister(URL_PETTY_CASH_REQUISITION, PENDING_APPROVAL),
    // },
    // {
    // label: "Approved",
    // icon: <CheckCircle />,
    // to: getRegister(URL_PETTY_CASH_REQUISITION, APPROVED),
    // },
    // {
    // label: "Deferred",
    // icon: <ReplayOutlined />,
    // to: getRegister(URL_PETTY_CASH_REQUISITION, DEFERRED),
    // },
    // {
    // label: "Rejected",
    // icon: <Cancel />,
    // to: getRegister(URL_PETTY_CASH_REQUISITION, REJECTED),
    // },
    // ],
    // },
    // ],
    // },

    // // ASSETS
    // {
    // label: "Assets Management",
    // icon: <Inventory2Outlined />,
    // visible: can(CAN_VIEW_ASSETS),
    // children: [
    // {
    // label: "Dashboard",
    // icon: <DashboardIcon />,
    // to: URL_ASSETS_DASHBOARD,
    // },
    // {
    // label: "New Asset",
    // icon: <Add />,
    // to: getForm(URL_ASSETS),
    // visible: can(CAN_REGISTER_ASSETS),
    // },
    // {
    // label: "Registered Assets",
    // icon: <Inventory2Outlined />,
    // to: getRegister(URL_ASSETS),
    // },
    // {
    // label: "Asset Transfers",
    // icon: <SwapHoriz />,
    // children: [
    // {
    // label: "New Transfer",
    // icon: <Add />,
    // to: getForm(URL_ASSET_TRANSFERS),
    // visible: can(CAN_TRANSFER_ASSETS),
    // },
    // ...approvalRegisters(URL_ASSET_TRANSFERS, <SwapHoriz />),
    // ],
    // },
    // {
    // label: "Assets Status Updates",
    // icon: <PublishedWithChanges />,
    // children: [
    // {
    // label: "New Status Update",
    // icon: <Add />,
    // to: getForm(URL_ASSET_STATUS_UPDATES),
    // visible: can(CAN_UPDATE_ASSET_STATUS),
    // },
    // {
    // label: "All",
    // icon: <PublishedWithChanges />,
    // to: getRegister(URL_ASSET_STATUS_UPDATES),
    // },
    // ],
    // },
    // {
    // label: "Assets Stock Counts",
    // icon: <FactCheckOutlined />,
    // children: [
    // {
    // label: "New Stock Count",
    // icon: <Add />,
    // to: getForm(URL_ASSET_STOCK_COUNTS),
    // visible: can(CAN_PERFORM_ASSET_STOCK_COUNT),
    // },
    // ...approvalRegisters(URL_ASSET_STOCK_COUNTS, <FactCheckOutlined />),
    // ],
    // },
    // {
    // label: "Assets Disposals",
    // icon: <DeleteSweepOutlined />,
    // children: [
    // {
    // label: "New Disposal Request",
    // icon: <Add />,
    // to: getForm(URL_ASSET_DISPOSALS),
    // visible: can(CAN_DISPOSE_ASSETS),
    // },
    // ...approvalRegisters(URL_ASSET_DISPOSALS, <DeleteSweepOutlined />),
    // ],
    // },
    // ],
    // },

    // BOOKINGS
    {
      label: "Bookings",
      icon: <ListAltOutlined />,
      visible: true,
      children: [
        {
          label: "All Bookings",
          icon: <Folder />,
          visible: true,
          children: [
            {
              label: "New Booking",
              icon: <Add />,
              to: `${URL_BOOKINGS}/create`,
              visible:
                isAgent || isAdmin || isSupper || isManager || isAccountant,
            },
            {
              label: "All Bookings",
              icon: <Clipboard />,
              to: `${getRegister(URL_BOOKINGS)}`,
              visible:
                isAgent || isAdmin || isSupper || isManager || isAccountant,
            },
          ],
        },

        {
          label: "Reserved Bookings",
          icon: <CheckmarkDone />,
          visible: isAgent || isSupper || isAdmin || isManager,
          children: [
            {
              label: SUBMITTED,
              icon: <Send />,
              to: `${getRegister(URL_BOOKINGS)}/${SUBMITTED}?booking_type=${RESERVATION}`,
              visible: true,
            },
            {
              label: APPROVED,
              icon: <CheckCircle />,
              to: `${getRegister(URL_BOOKINGS)}/${APPROVED}?booking_type=${RESERVATION}`,
              visible: true,
            },
            {
              label: CONFIRMED,
              icon: <Check />,
              to: `${getRegister(URL_BOOKINGS)}/${CONFIRMED}?booking_type=${RESERVATION}`,
              visible: true,
            },
            {
              label: REJECTED,
              icon: <Cancel />,
              to: `${getRegister(URL_BOOKINGS)}/${REJECTED}?booking_type=${RESERVATION}`,
              visible: true,
            },
          ],
        },

        {
          label: "E-Coupon Bookings",
          icon: <HourglassOutline />,
          visible: true,
          children: [
            // ADVANCE BALANCE CHECK
            {
              label: "Check E-Coupon Balance",
              icon: <Search />,

              click: () => {
                setOpenAdvanceBalance();
              },
            },
            {
              label: SUBMITTED,
              icon: <Send />,
              to: `${getRegister(URL_BOOKINGS)}/${SUBMITTED}?booking_type=${ADVANCE}`,
              visible: isAgent || isSupper || isAdmin || isManager,
            },

            {
              label: CONFIRMED,
              icon: <Check />,
              to: `${getRegister(URL_BOOKINGS)}/${CONFIRMED}?booking_type=${ADVANCE}`,
              visible: isAgent || isSupper || isAdmin || isManager,
            },

            {
              label: "E-Coupon Balances",
              icon: <AccountBalanceWallet />,
              to: getRegister(URL_ADVANCES_BALANCE),
              visible: isAgent || isSupper || isAdmin || isManager,
            },
            {
              label: "E-Coupon Transactions",
              icon: <ReceiptLong />,
              to: getRegister(URL_ADVANCES_TRANSACTIONS),
              visible:
                isAgent ||
                isSupper ||
                isAdmin ||
                isHeadOfAccountant ||
                isSupper ||
                isManager ||
                isAccountant,
            },
            {
              label: "Reversal Requests",
              icon: <ReplayOutlined />,
              to: getRegister(URL_REVERSAL_REQUESTS),
              visible:
                isHeadOfAccountant || isSupper || isManager || isAccountant,
            },
            {
              label: "Reversal Holdings",
              icon: <ReceiptLong />,
              to: getRegister(URL_REVERSAL_HOLDINGS),
              visible:
                isHeadOfAccountant || isSupper || isManager || isAccountant,
            },
            {
              label: "Dormant Accounts",
              icon: <ReceiptLong />,
              to: getRegister(URL_DORMANT_ACCOUNTS),
              visible:
                isHeadOfAccountant ||
                isSupper ||
                isManager ||
                isAccountant ||
                isAdmin,
            },
            {
              label: "Linked Cars",
              icon: <Car />,
              to: getRegister(URL_LINKED_CARS),
              visible: isSupper || isAdmin,
            },
          ],
        },

        {
          label: "Sticker Bookings",
          icon: <Pricetags />,
          visible: isAgent || isSupper || isAdmin || isManager,
          children: [
            {
              label: APPROVED,
              icon: <CheckCircle />,
              to: `${getRegister(URL_BOOKINGS)}/${APPROVED}?booking_type=${STICKER}`,
              visible: true,
            },
            {
              label: CONFIRMED,
              icon: <Check />,
              to: `${getRegister(URL_BOOKINGS)}/${CONFIRMED}?booking_type=${STICKER}`,
              visible: true,
            },
          ],
        },
      ],
    },

    // LIQUIDATION
    {
      label: "Liquidation",
      icon: <RequestPageOutlinedIcon />,
      visible: isHeadOfAccountant,
      children: [
        {
          label: "New Request",
          icon: <Add />,
          to: getForm(URL_LIQUIDATION_REQUESTS),
        },
        {
          label: "Liquidation Requests",
          icon: <Document />,
          to: getRegister(URL_LIQUIDATION_REQUESTS),
        },
      ],
    },

    {
      label: "Coupons",
      icon: <TicketOutline />,
      to: getRegister(URL_LIQUIDATION_REQUESTS),
      visible: isAccountant || isHeadOfAccountant || isSupper || isAdmin,
      children: [
        {
          label: "Coupon Sales",
          icon: <Ticket />,
          visible: isAgent || isSupper || isAdmin || isManager,
          to: getRegister(URL_COUPON_SALES),
        },
      ],
    },

    // LEDGERS
    {
      label: "Ledgers",
      icon: <LayersOutline />,
      visible: isAdmin || IsAccountant() || isSupper,
      children: [
        {
          label: "General Ledger",
          icon: <DocumentTextOutline />,
          to: URL_LEDGERS,
          visible: isAdmin || IsAccountant() || isSupper,
        },
        {
          label: "Trail Balance",
          icon: <TrainOutline />,
          visible: isAgent || isSupper || isAdmin || isManager || isAccountant,
          to: getRegister(URL_TRANSACTABLE_ACCOUNTS_DETAILS),
        },
      ],
    },

    // RECONCILIATIONS
    {
      label: "Reconciliations",
      icon: <SyncAltOutlined />,
      visible: isHeadOfAccountant,
      children: [
        {
          label: "All Reconciliations",
          icon: <SyncAlt />,
          to: getRegister(URL_RECONCILIATIONS),
          visible: isHeadOfAccountant,
        },
        {
          label: "System Logs",
          icon: <Info />,
          visible: isHeadOfAccountant,
          children: [
            {
              label: "Reconciliation Error Logs",
              icon: <Assessment />,
              to: getRegister(URL_RECONCILIATION_ERROR_LOGS),
            },
            {
              label: "Statement Logs",
              icon: <Article />,
              to: getRegister(URL_STATEMENT_LOGS),
            },
          ],
        },
      ],
    },

    // SETTINGS
    {
      icon: <SettingsOutline />,
      label: "Settings",
      to: "/settings",
      visible: isSupper || isAdmin || isHeadOfAccountant,
    },
  ];

  return menu;
}

export const LeftMenu = () => {
  const { data } = useGlobalContext();
  const settingsItems = useSettings();
  const leftMenuItems = LeftMenuItems();
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  useEffect(() => {
    setOpenKeys([]);
  }, [data?.showSettings]);

  const onOpenChange = (keys: string[]) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    if (!latestOpenKey) {
      setOpenKeys(keys);
      return;
    }
    setOpenKeys(
      keys.filter(
        (key) => key === latestOpenKey || latestOpenKey.startsWith(`${key}-`),
      ),
    );
  };

  return (
    <MenuShell>
      <StyledMenu
        className="font13 sidebar-nav-menu"
        mode="inline"
        defaultSelectedKeys={["default"]}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      >
        {RecursiveMenu(data?.showSettings ? settingsItems : leftMenuItems)}
      </StyledMenu>
    </MenuShell>
  );
};

const MenuShell = styled.div`
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: hidden;
`;

const StyledMenu = styled(Menu)`
  &&.ant-menu {
    min-height: 0;
    flex: 1;
    border-inline-end: 0;
    background: transparent;
    color: #334155;
    padding: 8px;
    overflow-y: auto;
  }

  &&.ant-menu-inline .ant-menu-item,
  &&.ant-menu-inline .ant-menu-submenu-title {
    height: auto;
    min-height: 40px;
    margin: 4px 0;
    width: 100%;
    border-radius: 10px;
    padding: 10px 12px !important;
    line-height: 1.35;
    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      box-shadow 0.2s ease;
  }

  && .ant-menu-item a,
  && .ant-menu-title-content {
    color: #334155;
    font-weight: 600;
  }

  && .ant-menu-item-icon,
  && .ant-menu-title-content > span > svg {
    color: #64748b;
  }

  && .ant-menu-item-icon {
    min-width: 18px;
    width: 18px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: color 0.2s ease;
  }

  && .ant-menu-item-selected {
    // background: linear-gradient(135deg, #215aa9 0%, #2b79c2 100%);
    background: #2563eb;
    // box-shadow: 0 8px 18px rgba(33, 90, 169, 0.24);
  }

  && .ant-menu-item-selected .ant-menu-title-content,
  && .ant-menu-item-selected .ant-menu-title-content a,
  && .ant-menu-item-selected .ant-menu-item-icon {
    color: #ffffff !important;
  }

  && .ant-menu-submenu-open > .ant-menu-submenu-title {
    background: #edf4ff;
    color: #1f4d91;
  }

  && .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-item-icon,
  && .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-title-content {
    color: #1f4d91;
  }

  && .ant-menu-submenu-arrow {
    color: #94a3b8;
  }

  && .ant-menu-sub.ant-menu-inline {
    margin: 2px 0 8px !important;
    padding: 6px !important;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.76);
  }

  && .ant-menu-sub.ant-menu-inline .ant-menu-item,
  && .ant-menu-sub.ant-menu-inline .ant-menu-submenu-title {
    padding-left: 12px !important;
  }

  && .ant-menu-sub.ant-menu-inline .ant-menu-sub.ant-menu-inline .ant-menu-item,
  &&
    .ant-menu-sub.ant-menu-inline
    .ant-menu-sub.ant-menu-inline
    .ant-menu-submenu-title {
    padding-left: 22px !important;
  }

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;
